import Row from './Row';


Row.install = function(Vue) {
  Vue.component(Row.name, Row);
};

export default Row;
